import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import { tabId } from 'src/components/Common/@electron/Tab';
import { TabItemProps } from 'src/components/Common/@electron/Tab/types';
import LazyImage from 'src/components/Common/LazyImage';
import { useExperienceEditor } from 'src/lib/Hooks/useExperienceEditor';

const TabItem = ({ fields, isActive, rendering }: TabItemProps) => {
  const { isEEActive } = useExperienceEditor();
  const shouldDisplay = isEEActive || isActive(fields);

  return (
    <div role="tabpanel" id={`panel-${tabId(fields)}`} aria-labelledby={`tab-${tabId(fields)}`}>
      {isEEActive && (
        <div>
          <h5>Tab Item</h5>
          <LazyImage {...fields.Icon} />
          <Text field={fields?.TabName} tag="div" />
        </div>
      )}
      {shouldDisplay && <Placeholder name="jss-public-tab-item-content" rendering={rendering} />}
    </div>
  );
};

export default TabItem;
